/**
 * Created by Jie Gao on 27/03/19.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite} from "gsap";
import {DragonTribeGameAssets} from "../DragonTribeGameAssets";
import {DragonTribeGameConfig} from "../DragonTribeGameConfig";
import {DragonTribeParsedGameData} from "../server/data/DragonTribeParsedGameData";
import {DragonTribeParsedInitData} from "../server/data/DragonTribeParsedInitData";

export class BetWaysOnReel extends BaseView {
    private static totalWays:string = (4 * 4 * 4 * 4 * 4 * 4).toString();
    private _layer:PIXI.Container;
    private _hasWin:boolean = false;
    private _textWays:PIXI.Sprite;
    private _textWaysRefresh:TimelineSprite;
    private _totalNumberOfWays:number;
    private _panel:PIXI.Sprite;
    private _betwaysInTotal:PIXI.BitmapText;
    private _isNextRespin:boolean = false;
    private _shouldUpdate:boolean;
    private _isPlayingAnimation:boolean;
    private _delayUpdate:boolean;
    private _isRestore:boolean;

    constructor() {
        super();
        this._layer = StageManager.getLayer(DragonTribeGameConfig.instance.LAYERS.BET_WAYS.name);
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onBeforeSpinStart());
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, SpinEvent.STOPPED, (event:GameEvent) => this.updateBetWays());
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_READY, (event:GameEvent) => this.updateBetWays());
    }

    private onInitGameDataParsed(data:DragonTribeParsedInitData):void {
        this._isRestore = data.isRestoreState;
        this._shouldUpdate = data.isRestoreState;
        this._totalNumberOfWays = data.totalNumberOfWays;
    }

    protected onGameDataParsed(data:DragonTribeParsedGameData):void {
        this._hasWin = data.singleWin > 0;
        this._totalNumberOfWays = data.totalNumberOfWays;
        this._isNextRespin = data.nextMode.indexOf("_AVALANCHE") > -1;
        this._shouldUpdate = false;
        data.mysterySymbolOnReel.forEach((hasMysterySymbol:boolean) => {
            if(hasMysterySymbol) {
                this._shouldUpdate = true;
            }
        });
    }

    private onBeforeSpinStart():void {
        this._delayUpdate = false;
        if(this._isRestore || this._isNextRespin) {
            this._isRestore = false;
            return;
        }
        if(!this._isPlayingAnimation) {
            this._betwaysInTotal.text = BetWaysOnReel.totalWays;
        } else {
            this._delayUpdate = true;
        }

    }

    public updateBetWays():void {
        if(!this._shouldUpdate) {
            return;
        }
        this._isPlayingAnimation = true;
        const tl:TimelineLite = new TimelineLite({
            paused : true,
            onComplete : () => {
                this._isPlayingAnimation = false;
                if(this._delayUpdate) {
                    this._betwaysInTotal.text = BetWaysOnReel.totalWays;
                    this._delayUpdate = false;
                }
            }
        });

        tl.add([() => {
            this._betwaysInTotal.text = this._totalNumberOfWays.toString();
            this._betwaysInTotal.x = Helper.getSymbolPositions(2, 0)[0] + GameConfig.instance.SYMBOL_WIDTH / 2 - this._betwaysInTotal.width;
        }, this._textWaysRefresh.getAnimationAutoShowHide(true, true)]);
        tl.play();
    }

    protected initAnimations():void {
        this._panel = new PIXI.Sprite();
        this._panel.x = DragonTribeGameConfig.instance.REEL_AREA_POS_X - 14;
        this._panel.y = 504;
        this._layer.addChild(this._panel);
        this._textWays = new PIXI.Sprite(GameResources.getTextures(DragonTribeGameAssets.WAYS)[0]);
        this._textWays.x = (DragonTribeGameConfig.instance.REEL_AREA_POS_X + DragonTribeGameConfig.instance.REEL_AREA_WIDTH / 2) + 20;
        this._textWays.y = DragonTribeGameConfig.instance.REEL_AREA_POS_Y + DragonTribeGameConfig.instance.REEL_AREA_TOP - 25;
        this._textWays.anchor.set(0, 1);
        this._layer.addChild(this._textWays);
        this._betwaysInTotal = new PIXI.BitmapText(BetWaysOnReel.totalWays, {
            fontName : "NumbersXWays",
            fontSize : 50
        });
        this._layer.addChild(this._betwaysInTotal);
        this._textWaysRefresh = new TimelineSprite(GameResources.getTextures("waysRefresh"));
        this._textWaysRefresh.x = Helper.getSymbolPositions(2, 0)[0] + GameConfig.instance.SYMBOL_WIDTH / 2 - this._betwaysInTotal.width;
        this._textWaysRefresh.y = 40;
        this._textWaysRefresh.anchor.set(0.5, 0.5);
        this._textWaysRefresh.blendMode = PIXI.BLEND_MODES.ADD;
        this._textWaysRefresh.hide();
        this._layer.addChild(this._textWaysRefresh);
    }

    protected onResize(data:IResizeData):void {
        this._betwaysInTotal.x = Helper.getSymbolPositions(2, 0)[0] + GameConfig.instance.SYMBOL_WIDTH / 2 - this._betwaysInTotal.width;
        this._betwaysInTotal.y = 20;
        this._textWaysRefresh.x = Helper.getSymbolPositions(2, 0)[0] + GameConfig.instance.SYMBOL_WIDTH / 2 - this._betwaysInTotal.width / 2;
        this._textWaysRefresh.y = 40;
    }

}

